export default __webpack_public_path__ + "static/GridGain_Logo_Alternate-cc356bd604f2b6b60c9f9142e84a7c54.svg";